import React, { useState, useEffect } from 'react'
import { Box, Flex, Select, Group, Button, TextInput, Card, Loader, Text, Checkbox } from '@mantine/core'
import { useDebouncedCallback } from '@mantine/hooks'
import { getAllCountryList } from '../../../services/location'
import LoadingData from '../../ui/LoadingData'
import { getAllWarehouseList } from '../../../services/warehouse'
import { getAllBrandList } from '../../../services/brands'
import { getAllSupplierList } from '../../../services/supplier'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  'filter[title][like]': null,
  'filter[original_title][like]': null,
  'filter[ali_sku][like]': null,
  'filter[id][is]': null,
  'filter[country_id][is]': null,
  'filter[warehouses.id][like]': null,
  'filter[tags.id][is]': null,
  'filter[brand_id][is]': null,
  'filter[supplier.name][like]': null,
}

const defaultTags = [
  {
    label: 'Wholesale',
    value: '1'
  },
  {
    label: 'Retail',
    value: '2'
  },
  {
    label: 'Hot Product',
    value: '3'
  },
  {
    label: 'Local',
    value: '4'
  },
  {
    label: 'Imported Product',
    value: '5'
  },
  {
    label: 'Fulfillment',
    value: '6'
  },
  {
    label: 'Group Buy',
    value: '7'
  },
  {
    label: 'Virtual',
    value: '8'
  },
  {
    label: 'COD',
    value: '9'
  },
  {
    label: 'Pre-Order',
    value: '10'
  },
  {
    label: 'Hot Product (Homepage)',
    value: '11'
  },
]

const FormFilterProduct= ({ paramsProducts, applyFilter, onClose }) => {
  const [parameter, setParameter] = useState(defaultParams)
  const [isOutOfStock, setIsOutOfStock] = useState(false)
  const [isNotCountry, setIsNotCountry] = useState(false)
  const [isAttachProduct, setIsAttachProduct] = useState(false)
  const [isAddByUser, setIsAddByUser] = useState(false)
  const [isAddByAdmin, setIsAddByAdmin] = useState(false)
  const [isNoWeightProduct, setIsNoWeightProduct] = useState(false)

  const [countryList, setCountryList] = useState([])
  const [loadingCountry, setLoadingCountry] = useState(true)

  const [warehouseList, setWarehouseList] = useState([])

  const [searchBrand, setSearchBrand] = useState('')
  const [brandList, setBrandList] = useState([])
  const [loadingBrand, setLoadingBrand] = useState(false)

  const [searchSupplier, setSearchSupplier] = useState('')
  const [supplierList, setSupplierList] = useState([])
  const [loadingSupplier, setLoadingSupplier] = useState(false)

  const handleGetListCountry = useDebouncedCallback(async () => {
    setLoadingCountry(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCountry(false)
    }
  }, 300)

  const handleGetListWarehouse = useDebouncedCallback(async () => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
    }
    try {
      const response = await getAllWarehouseList(parameter)
      const dataWarehouses = response.data
      const remapDataWarehouses = dataWarehouses.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setWarehouseList(remapDataWarehouses)
    } catch (error) {
      console.log(error)
    }
  }, 300)


  const handleGetListBrand = useDebouncedCallback(async (id) => {
    setLoadingBrand(true)
    const parameter = {
      'filter[id][is]': id,
      'filter[name][like]': searchBrand,
      'page[num]': 1,
      'page[limit]': 10,
    }
    try {
      const response = await getAllBrandList(parameter)
      const dataBrands = response.data
      const remapDataBrands = dataBrands.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setBrandList(remapDataBrands)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingBrand(false)
    }
  }, 300)

  const handleGetListSupplier = useDebouncedCallback(async () => {
    setLoadingSupplier(true)
    const parameter = {
      'filter[name][like]': searchSupplier,
      'page[num]': 1,
      'page[limit]': 10, // bad habbit
      'fields[supplier]': 'name'
    }

    try {
      const response = await getAllSupplierList(parameter)
      const dataSuppliers = response.data
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: val.attributes.name,
          label: val.attributes.name
        }
      })
      setSupplierList(remapDataSuppliers)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSupplier(false)
    }
  }, 300)

  useEffect(() => {
    if (paramsProducts !== null) {
      handleSetParams(paramsProducts)
    }
    // eslint-disable-next-line
  }, [paramsProducts])

  useEffect(() => {
    handleGetListCountry()
    handleGetListWarehouse()
    if (paramsProducts['filter[brand_id][is]']) {
      handleGetListBrand(paramsProducts['filter[brand_id][is]'])
    }

    if(paramsProducts['filter[quantity]'] === 0) {
      setIsOutOfStock(true)
    }
    if (paramsProducts['filter[country_id][null]']) {
      setIsNotCountry(true)
    }
    if (paramsProducts['imported']) {
      setIsAttachProduct(true)
    }
    if (paramsProducts['filter[merchant][null]'] === false) {
      setIsAddByUser(true)
    }
    if (paramsProducts['filter[merchant][null]'] === true) {
      setIsAddByAdmin(true)
    }
    if (paramsProducts['filter[weight][is]' === 0]) {
      setIsNoWeightProduct(true)
    }
    if (paramsProducts['filter[supplier.name][like]']) {
      setSearchSupplier(paramsProducts['filter[supplier.name][like]'])
      // handleGetListSupplier(paramsProducts['filter[supplier.name][like]'])
    }
    // eslint-disable-next-line
  }, [paramsProducts])

  useEffect(() => {
    handleGetListBrand()
    // eslint-disable-next-line
  }, [searchBrand])

  useEffect(() => {
    handleGetListSupplier()
    // eslint-disable-next-line
  }, [searchSupplier])

  const handleSetParams = (val) => {
    const prevParams = {
      'filter[title][like]':  val['filter[title][like]'],
      'filter[original_title][like]': val['filter[original_title][like]'],
      'filter[ali_sku][like]': val['filter[ali_sku][like]'],
      'filter[id][is]': val['filter[id][is]'],
      'filter[country_id][is]': val['filter[country_id][is]'],
      'filter[warehouses.id][like]': val['filter[warehouses.id][like]'],
      'filter[tags.id][is]': val['filter[tags.id][is]'],
      'filter[brand_id][is]': val['filter[brand_id][is]'],
      'filter[supplier.name][like]': val['filter[supplier.name][like]']
    }
    setParameter(prevParams)
  }

  const handleChangeFilter = (name, val) => {
    setParameter((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    const valueParams = {
      ...params,
      'page[num]': 1,
      'page[limit]': 10,
    }

    if (isOutOfStock) {
      valueParams['filter[quantity]'] = 0
    }
    if (isNotCountry) {
      valueParams['filter[country_id][null]'] = true
    }
    if (isAttachProduct) {
      valueParams['imported'] = true
    }
    if (isAddByUser) {
      valueParams['filter[merchant][null]'] = false
    }
    if (isAddByAdmin) {
      valueParams['filter[merchant][null]'] = true
    }
    if (isNoWeightProduct) {
      valueParams['filter[weight][is]'] = 0
    }

    applyFilter(valueParams)
    onClose()
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const mappingFormFilter = () => {
    return (
      <Box>
        <Card shadow="xs" radius="md" withBorder mb='md'>
          <Text fw={500} size='sm'>Quick Filter</Text>
          <Box my='md'>
            <Checkbox
              size='xs'
              label="Out of stock Products"
              description="The list of products that have no stock."
              checked={isOutOfStock}
              onChange={(event) => setIsOutOfStock(event.currentTarget.checked)}
            />
          </Box>
          <Box mb='md'>
            <Checkbox
              size='xs'
              label="Not Country"
              description="The list of products that have no country."
              checked={isNotCountry}
              onChange={(event) => setIsNotCountry(event.currentTarget.checked)}
            />
          </Box>
          <Box mb='md'>
            <Checkbox
              size='xs'
              label="Attached to My Products"
              description="The list of products that attached to User My Channel"
              checked={isAttachProduct}
              onChange={(event) => setIsAttachProduct(event.currentTarget.checked)}
            />
          </Box>
          <Box mb='md'>
            <Checkbox
              size='xs'
              label="Add By User"
              description="The list of products that Add by User"
              checked={isAddByUser}
              onChange={(event) => setIsAddByUser(event.currentTarget.checked)}
            />
          </Box>
          <Box mb='md'>
            <Checkbox
              size='xs'
              label="Add By Admin"
              description="The list of products that Add by Admin"
              checked={isAddByAdmin}
              onChange={(event) => setIsAddByAdmin(event.currentTarget.checked)}
            />
          </Box>
          <Box>
            <Checkbox
              size='xs'
              label="No Weight Products"
              description="The list of products that have no weight"
              checked={isNoWeightProduct}
              onChange={(event) => setIsNoWeightProduct(event.currentTarget.checked)}
            />
          </Box>
        </Card>

        <Card shadow="xs" radius="md" withBorder mb='md'>
          <Box mb='md'>
            <TextInput
              name='filter[title][like]'
              label='Product Title'
              value={parameter['filter[title][like]']}
              onChange={(val) => handleChangeFilter('filter[title][like]', val.target.value)}
              size='xs'
            />
          </Box>

          <Box mb='sm'>
            <TextInput
              name='filter[original_title][like]'
              label='Original Language'
              value={parameter['filter[original_title][like]']}
              onChange={(val) => handleChangeFilter('filter[original_title][like]', val.target.value)}
              size='xs'
            />
          </Box>
          
          <Box mb='sm'>
            <TextInput
              name='filter[ali_sku][like]'
              label='ALI-SKU'
              value={parameter['filter[ali_sku][like]']}
              onChange={(val) => handleChangeFilter('filter[ali_sku][like]', val.target.value)}
              size='xs'
            />
          </Box>

          <Box mb='sm'>
            <TextInput
              name='filter[id][is]'
              label='Product Id'
              value={parameter['filter[id][is]']}
              onChange={(val) => handleChangeFilter('filter[id][is]', val.target.value)}
              size='xs'
            />
          </Box>
        </Card>

        <Card shadow="xs" radius="md" withBorder mb='md'>
          <Select
            name='filter[country_id][is]'
            value={parameter['filter[country_id][is]']}
            label='Country'
            data={countryList}
            onChange={(val) => handleChangeFilter('filter[country_id][is]', val)}
            size='xs'
            clearable
            searchable
          />
        </Card>

        <Card shadow="xs" radius="md" withBorder mb='md'>
          <Select
            name='filter[supplier.name][like]'
            value={parameter['filter[supplier.name][like]']}
            label='Supplier'
            data={supplierList}
            onChange={(val) => handleChangeFilter('filter[supplier.name][like]', val)}
            size='xs'
            clearable
            searchable
            searchValue={searchSupplier}
            onSearchChange={setSearchSupplier}
            nothingFoundMessage={!loadingSupplier ? supplierList.length > 0 ? '' : 'No Supplier Found' : loadingDataTemplate()}
          />
        </Card>

        <Card shadow="xs" radius="md" withBorder mb='md'>
          <Select
            name='filter[warehouses.id][like]'
            value={parameter['filter[warehouses.id][like]']}
            label='Warehouse'
            data={warehouseList}
            onChange={(val) => handleChangeFilter('filter[warehouses.id][like]', val)}
            size='xs'
            clearable
            searchable
          />
        </Card>

        <Card shadow="xs" radius="md" withBorder mb='md'>
          <Select
            name='filter[tags.id][is]'
            value={parameter['filter[tags.id][is]']}
            label='Tag / Label'
            data={defaultTags}
            onChange={(val) => handleChangeFilter('filter[tags.id][is]', val)}
            size='xs'
            clearable
            searchable
          />
        </Card>
        
        <Card shadow="xs" radius="md" withBorder mb='md'>
          <Select
            name='filter[brand_id][is]'
            value={parameter['filter[brand_id][is]']}
            label='Brands'
            data={brandList}
            onChange={(val) => handleChangeFilter('filter[brand_id][is]', val)}
            size='xs'
            clearable
            searchable
            searchValue={searchBrand}
            onSearchChange={setSearchBrand}
            nothingFoundMessage={!loadingBrand ? brandList.length > 0 ? '' : 'No Brand Found' : loadingDataTemplate()}
          />
        </Card>

        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onClose}>Close</Button>
              <Button size='xs' variant="filled" onClick={() => handleApplyFilter(parameter)}>Apply Filter</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      {loadingCountry ? <LoadingData /> : mappingFormFilter()}
    </Box>
  )
}

export default FormFilterProduct